import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const FallbackAvatar = (props) => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    __spreadValues({
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */ React.createElement("mask", { id: "mask0_51:19729", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "36", height: "36" }, /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "18", r: "18", fill: "#E6E6E6" }), /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "18", r: "18", fill: "#E6E6E6" })),
    /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_51:19729)" }, /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "18", r: "18", fill: "#F0F0F0" }), /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "14", r: "7", fill: "#A6A6A6" }), /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "41", r: "18", fill: "#A6A6A6" }))
  );
};

export { FallbackAvatar as default };
//# sourceMappingURL=FallbackAvatar.js.map
